import React, { useMemo, useState } from 'react';
import { createContext } from '../dissolve/utils';

export interface CandyCartContextShape {
  cartTotal: number | undefined;
  setCartTotal: (total: number) => void;
}

const [useCandyCartContext, ContextProvider, ContextConsumer] =
  createContext<CandyCartContextShape>();

interface Props {
  children: React.ReactNode;
}

const CandyCartContextProvider = ({ children }: Props) => {
  const [cartTotal, setCartTotal] = useState<number>(0);

  const providerValue: CandyCartContextShape = useMemo(
    () => ({
      cartTotal,
      setCartTotal,
    }),
    // eslint-disable-next-line
    [cartTotal],
  );

  return <ContextProvider value={providerValue}>{children}</ContextProvider>;
};

const CandyCartContextConsumer =
  ContextConsumer as React.Consumer<CandyCartContextShape>;

export {
  useCandyCartContext,
  CandyCartContextProvider,
  CandyCartContextConsumer,
};
